export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Institution.vue?vue&type=template&id=52704161&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/sections/Institution.vue?vue&type=template&id=52704161&scoped=true&
// module id = 1366
// module chunks = 0